import gql from 'graphql-tag';

const GET_SERVICE_CATEGORIES = gql`
  query {
    getServiceCategories {
      categoryId
      name
    }
  }
`;

const GET_SERVICE_ITEMS = gql`
  query getServiceItems($listInfo: ListInfoInput) {
    getServiceItems(listInfo: $listInfo) {
      items {
        itemId
        name
        isDefault
        invoiceDescription
        quantityType
        roundUpValue
        unitPrice
        category {
          categoryId
          name
        }
        businessHoursUnitPrice
        afterHoursUnitPrice
        useAsWorklogItem
        quantity
        amount
        integrationState {
          xero
          quickbooks
          pax8
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;
const GET_SERVICE_ITEMS_FOR_IT = gql`
  query getServiceItems($listInfo: ListInfoInput) {
    getServiceItems(listInfo: $listInfo) {
      items {
        itemId
        name
        invoiceDescription
        category {
          categoryId
          name
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_SERVICE_ITEM_FOR_IT = gql`
  query getServiceItem($itemId: ID!) {
    getServiceItem(itemId: $itemId) {
      itemId
      name
      invoiceDescription
      category {
        categoryId
        name
      }
    }
  }
`;

const GET_SERVICE_ITEM = gql`
  query getServiceItem($itemId: ID!) {
    getServiceItem(itemId: $itemId) {
      itemId
      name
      invoiceDescription
      quantityType
      roundUpValue
      unitPrice
      costPrice
      category {
        categoryId
        name
      }
      businessHoursUnitPrice
      afterHoursUnitPrice
      useAsWorklogItem
      quantity
      amount
      blockItemAdjustedItems {
        itemId
        name
      }
      blockItemUsedIn
      adjustBlockItemAgainstAllItems
      salesTaxEnabled
      salesTax {
        taxId
        name
      }
      isDefault
      integrationState {
        xero
        quickbooks
        pax8
      }
      integrationAddOn {
        addOnId
        addOn
      }
    }
  }
`;

export {
  GET_SERVICE_CATEGORIES,
  GET_SERVICE_ITEMS,
  GET_SERVICE_ITEMS_FOR_IT,
  GET_SERVICE_ITEM_FOR_IT,
  GET_SERVICE_ITEM
};
